import AnimatedPage from "@/components/AnimatedPage";
import HeaderBox from "@/components/HeaderBox";
import HelmetMetaData from "@/components/HelmetMetaData";
import SchoolTiles from "@/components/dashboard/SchoolTiles";
import BuyExamForm from "@/components/forms/BuyExamForm";
import { Link } from "react-router-dom";

const BuyExamPins = () => {
  // return (
  //   <AnimatedPage>
  //     <ComingSoon />
  //   </AnimatedPage>
  // );
  return (
    <>
      <AnimatedPage>
        <HelmetMetaData
          title="Buy Exam Pins & Tokens"
          description="Purchase your exam pins and tokens easily to access and check your exam results. Secure your academic success with our fast and reliable service!"
        />
        <section className="p-3 sm:p-5">
          <div className="flex flex-col-reverse items-start justify-between md:flex-row">
            <HeaderBox
              title="Buy Exam Pins & Tokens"
              subtext="Purchase your exam pins and tokens to check your results—stay informed!"
            />

            <div>
              <h2 className="text-sm font-medium">
                <Link to="/dashboard" className="hover:underline">
                  Dashboard
                </Link>

                <span className="px-2 text-xl font-thin">/</span>

                <span className="text-gray-400">Buy Exam Tokens</span>
              </h2>
            </div>
          </div>

          <SchoolTiles />
          <BuyExamForm />
        </section>
      </AnimatedPage>
    </>
  );
};

export default BuyExamPins;
